import { render, staticRenderFns } from "./design-display.vue?vue&type=template&id=5f3ee87e&scoped=true"
import script from "./design-display.vue?vue&type=script&lang=js"
export * from "./design-display.vue?vue&type=script&lang=js"
import style0 from "./design-display.vue?vue&type=style&index=0&id=5f3ee87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ee87e",
  null
  
)

export default component.exports